<script setup>
import { ref, onBeforeMount, computed } from "vue"
import CarteleraSubastas from "./CarteleraSubastas.vue"
import CarteleraLotes from "./CarteleraLotes.vue"
import CarteleraFiltrosSubasta from "./filtros/CarteleraFiltrosSubasta.vue"
import CarteleraFiltrosLote from "./filtros/CarteleraFiltrosLote.vue"
import { useListadosEntidadesStore } from "@/store/listadosEntidadesStore"

const props = defineProps({
  carteleraStore: Object,
})

const listadosEntidadesStore = useListadosEntidadesStore();
const seccionActual = ref("subastas");
const secciones = [
  { slug: "subastas", texto: "Ver subastas" },
  { slug: "lotes", texto: "Ver lotes" },
];

function setSeccionActual(seccion) {
  seccionActual.value = seccion;
}

onBeforeMount(() => {
  listadosEntidadesStore.getIndustrias({
    with_count_subastas: true,
    sort_column: "subastas_count",
    order_by: "desc",
  })
  listadosEntidadesStore.getCategorias()
})

const totalSubastas = computed(
  () => props.carteleraStore?.subastas?.meta?.total ??
    props.carteleraStore?.subastas?.data?.length ?? 0
)
const totalLotes = computed(
  () => props.carteleraStore?.lotes?.meta?.total ??
    props.carteleraStore?.lotes?.data?.length ?? 0
)
</script>

<template>

  <div class="container my-4 pe-md-0 ps-md-0">
    <div class="row g-4">
      <!-- Sidebar filtros -->
      <aside class="col-12 col-lg-4">  
        <div class="row mb-3">
            <div class="d-flex gap-3 w-100">
              <button v-for="seccion in secciones"
                :key="seccion.slug"
                class="btn btn-light bg-soft-grey-ee text-black shadow-none rounded-2 text-center"
                :class="{ 'text-soft-green': seccionActual === seccion.slug }"
                @click="setSeccionActual(seccion.slug)"
                :aria-selected="seccionActual === seccion.slug"
                style="flex:1 1 0;">
                {{ seccion.texto }}
              </button>
            </div>
        </div>
        <div class="sticky-md-top" style="top: 16px;" v-if="seccionActual === 'subastas'">
          <CarteleraFiltrosSubasta :carteleraStore="props.carteleraStore" :listadosEntidadesStore="listadosEntidadesStore" />
        </div>
        <div v-else>
          <CarteleraFiltrosLote :carteleraStore="props.carteleraStore" :listadosEntidadesStore="listadosEntidadesStore" />
        </div>
      </aside>

      <!-- Main -->
      <main class="col-12 col-lg-8">
        <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">

          <p class="mb-0 fs-3 text-black fw-500" v-if="seccionActual === 'subastas'">Cartelera de subastas</p>
          <p class="mb-0 fs-3 text-black fw-500" v-else>Cartelera de lotes</p>

          <small v-if="seccionActual === 'subastas'" class="text-black">
            Mostrando {{ totalSubastas }} subastas <span class="text-muted">({{ props.carteleraStore?.subastas?.data?.length }})</span>
          </small>
          <small v-else class="text-black">
            Mostrando {{ totalLotes }} lotes <span class="text-muted">({{ props.carteleraStore?.lotes?.data?.length }})</span>
          </small>
        </div>

        <CarteleraSubastas v-if="seccionActual === 'subastas'" :carteleraStore="props.carteleraStore"
          :listadosEntidadesStore="listadosEntidadesStore" />

        <CarteleraLotes v-else :carteleraStore="props.carteleraStore"
          :listadosEntidadesStore="listadosEntidadesStore" />
      </main>
    </div>
  </div>
</template>

<style scoped>
.btn-light.active,
.btn-light:active,
.btn-light[aria-selected="true"] {
  color: #006C4C !important;
}
</style>
